import React, { useState } from "react";

import SideMenuItem from "./MenuItem";
import influxLogo from "~/images/influx_logo.png";
import { Link } from "react-router-dom";

export default function Menu({ items = [] }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <section
        id="menu"
        className="w-screen h-[80px] p-4 lg:flex hidden shadow bg-white"
      >
        <Link to={"/"}>
          <img
            src={influxLogo}
            alt=""
            className="max-w-[100px] absolute left-10 top-4"
          />
        </Link>

        <div className="flex space-x-10 justify-center w-full items-center">
          {items.map((i) => (
            <SideMenuItem {...i} key={i.menuKey} menuKey={i.menuKey} />
          ))}
        </div>
      </section>

      <section
        id="burger-menu"
        className="w-screen h-[55px] flex lg:hidden justify-end shadow bg-white"
      >
        <div className="space-y-2 px-6 py-4" onClick={toggleMenu}>
          <span className="block h-0.5 w-8 animate-pulse bg-gray-600"></span>
          <span className="block h-0.5 w-8 animate-pulse bg-gray-600"></span>
          <span className="block h-0.5 w-8 animate-pulse bg-gray-600"></span>
        </div>

        <div className={isMenuOpen ? "showMenuNav" : "hideMenuNav"}>
          <div
            className="absolute top-0 right-0 px-6 py-4"
            onClick={toggleMenu}
          >
            <svg
              className="h-8 w-8 text-gray-600"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </div>
          <div className="flex flex-col space-y-10 justify-center w-full items-center">
            {items.map((i, index) => (
              <div onClick={toggleMenu} key={index}>
                <SideMenuItem {...i} key={i.menuKey} menuKey={i.menuKey} />
              </div>
            ))}
          </div>
        </div>
      </section>
      <style>{`
      .hideMenuNav {
        display: none;
      }
      .showMenuNav {
        display: block;
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        background: white;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
      }
    `}</style>
    </>
  );
}
